import React from "react";
import { Card } from "@shopify/polaris";
import { Col, Row } from "reactstrap";
import Checkify from "../../assets/integrations/checkify.png";
import Tele from "../../assets/integrations/tele.png";
import Checkoutx from "../../assets/integrations/checkoutx.png";
import Layout from "./Layout";
const EndCheckout = () => {
  const listCheckout = [
    {
      title: "The Responsive Shopify Checkout",
      description: "One-page checkout for Shopify stores",
      logo: Checkify,
      crispEvent: "Checkify",
    },
    {
      title: "Easy Online Shopping",
      description: "Smater Shopping, Better Living",
      logo: Tele,
      crispEvent: "TeleCheckout",
    },
    {
      title: "The Checkout to Sell More",
      description:
        "Reduce abandoned checkouts by 7%+ with a frictionless flow.",
      logo: Checkoutx,
      crispEvent: "Checkout-X",
    },
  ];
  return (
    <div style={{ marginTop: "10px" }}>
      <Card sectioned title="End Checkout">
        <Row>
          {listCheckout.map((item, index) => {
            return (
              <Col md="4">
                <Layout
                  title={item.title}
                  description={item.description}
                  logo={item.logo}
                  crispEvent={item.crispEvent}
                />
              </Col>
            );
          })}
        </Row>
      </Card>
    </div>
  );
};

export default EndCheckout;
